import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getWebQuoteLoginLinkConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'login_token_link/web_quote_login_link',
    method: NetworkRequestConfiguration.Methods.GET,
  });
}
